export default function QuotesIcon() {
  return (
    <svg
      width="12"
      height="21"
      viewBox="0 0 12 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.50004 1.875V19.125M10.0257 5.35796C8.47708 3.09122 2.61439 2.85438 2.61439 6.82714C2.61439 10.7999 11.0544 8.89958 10.5671 13.578C10.1608 17.4789 3.80999 17.5326 1.91052 14.4187"
        stroke="currentColor"
        strokeWidth="1.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
